export default __webpack_public_path__ + "static/media/notifications.b3866216.svg";